import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FlexGrid, CellRangeEventArgs } from '@grapecity/wijmo.grid';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1509Model } from './kymw1509.model';
import { UpdateCwsIconPublishOrderVo } from './vo/update-cws-Icon-publish-order.model';
import { GetMarkGroupListService } from '../kymw1500/api-services/get-mark-group-list.service';
import { GetCwsIconPublishOrderList } from './api-services/get-cws-icon-publish-order-list-service';
import { UpdateCwsIconPublishOrder } from './api-services/update-cws-icon-publish-order-service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessAlert } from 'src/app/shared/pless-alert/pless-alert.component';

/**
 * アイコン掲載順設定画面を管理するクラス
 *
 * @export KYMW1509Component
 * @class KYMW1509Component
 */
@Component({
  selector: 'app-kymw1509',
  templateUrl: 'kymw1509.component.html',
  styleUrls: ['kymw1509.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1509Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('dtg_IconList', { static: true }) dtg_IconList: FlexGrid;

  kymw1509Model: KYMW1509Model = new KYMW1509Model();
  private dragIndex: number;
  private changeFlag = false;

  /**
   *Creates an instance of KYMW1509Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1509Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private getMarkGroupListService: GetMarkGroupListService,
    private getCwsIconPublishOrderListService: GetCwsIconPublishOrderList,
    private updateCwsIconPublishOrderService: UpdateCwsIconPublishOrder,
    private elementRef: ElementRef,
    ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1509Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1509';
    this.dtg_IconList.columnHeaders.rows[0].height = 52;
    this.dtg_IconList.rowHeaders.columns[0].minWidth = 5;

    // マークグループ一覧取得
    this.getMarkGroupListService.execute((data: any) => {
      if (PlessViewUtilsSub.isEmptyArray(data)) {
        // マークグループコードが取得できませんでした
        this.dialogService.openAlertGetMessage('E0127', null, () => {
          this.closeFunction();
        });
      }
      this.kymw1509Model.updateMarkGroupList(data);
      // 行変更前のリストを保存
      if(this.kymw1509Model.iconListMap[this.kymw1509Model.selectedMarkGroup] != null) {
        this.kymw1509Model.beforeChangeIconList = this.kymw1509Model.iconListMap[this.kymw1509Model.selectedMarkGroup].reduce((list, mark) => {
          list.push(mark);
          return list;
        },[]);
      }
    });
  }

  /**
   * 画面初期値設定
   *
   * @param groupCode マークグループコード
   * @memberof KYMW1509Component
   */
  public setInterfaceParam(groupCode: string) {
    this.kymw1509Model.selectedMarkGroup = groupCode;
    this.kymw1509Model.beforeChangeSelectedMarkGroup = groupCode;

    // アイコン掲載順一覧取得取得
    // ngOnInitにあった処理だが、ここで動かないと初期表示でリストが表示できないので移動してきた
    this.getCwsIconPublishOrderListService.execute((data: any) => {
      if (PlessViewUtilsSub.isEmptyArray(data)) {
        // アイコン情報が取得できませんでした
        this.dialogService.openAlertGetMessage('E0547', null, () => {
          this.closeFunction();
        });
      }
      this.kymw1509Model.updateIconListMap(data);
      setTimeout(() => {
        // グループコンボボックス選択値に応じた表の表示とするため遅延評価
        this.eventMarkGroupName_CHANGEHandler();
      }, 500);    
      setTimeout(() => {
        // 表の行の縦幅を画像表示後のサイズに調整するため遅延評価
        this.dtg_IconList.refresh();
      }, 1000);
    });
  }

  /**
   * グループ コンボボックス 変更
   *
   * @memberof KYMW1509Component
   */
  public eventMarkGroupName_CHANGEHandler() {
    const before = this.kymw1509Model.beforeChangeSelectedMarkGroup;
    const beforeList = this.kymw1509Model.beforeChangeIconList;

    if (this.changeFlag) {
      // 並び順の変更を破棄してもよろしいですか？
      this.dialogService.openAlertGetMessage('Q0169', null, (c) => {
        if (c === PlessAlert.Yes) {
          this.changeFlag = false;
          this.kymw1509Model.displayIconList = this.kymw1509Model.iconListMap[this.kymw1509Model.selectedMarkGroup];
          this.kymw1509Model.iconListMap[before] = beforeList;
        } else {
          this.kymw1509Model.selectedMarkGroup = before;
          return;
        }
      });
    } else {
      this.kymw1509Model.displayIconList = this.kymw1509Model.iconListMap[this.kymw1509Model.selectedMarkGroup];
    }
    this.kymw1509Model.beforeChangeSelectedMarkGroup = this.kymw1509Model.selectedMarkGroup;
    if(this.kymw1509Model.iconListMap[this.kymw1509Model.selectedMarkGroup] != null) {
      this.kymw1509Model.beforeChangeIconList = this.kymw1509Model.iconListMap[this.kymw1509Model.selectedMarkGroup].reduce((list, mark) => {
        list.push(mark);
        return list;
      },[]);
    }
  }

  /**
   * アイコン 一覧 行ドラッグ
   *
   * @memberof KYMW1509Component
   */
  public onDraggingRow(s: FlexGrid, e: CellRangeEventArgs) {
    this.dragIndex = e.row;
    s.collectionView.moveCurrentToPosition(this.dragIndex);
  }

  /**
   * アイコン 一覧 行ドロップ
   *
   * @memberof KYMW1509Component
   */
  public onDraggedRow(s: FlexGrid, e: CellRangeEventArgs) {
    this.changeFlag = true;
    const dropIndex = e.row;

    // 掲載順を入れ替え
    const temp = this.dtg_IconList.rows[this.dragIndex].dataItem.publishOrder;
    this.dtg_IconList.rows[this.dragIndex].dataItem.publishOrder = this.dtg_IconList.rows[dropIndex].dataItem.publishOrder;
    this.dtg_IconList.rows[dropIndex].dataItem.publishOrder = temp;

    const arr = s.collectionView.sourceCollection;
    s.collectionView.deferUpdate(() => {
      let item = arr[this.dragIndex];
      arr.splice(this.dragIndex, 1);
      arr.splice(dropIndex, 0, item);
      s.collectionView.moveCurrentToPosition(dropIndex);
    });
  }

  /**
   * 設定 ボタン 押下
   *
   * @memberof KYMW1509Component
   */
  public eventSetting_CLICKHandler() {
    const updateList: UpdateCwsIconPublishOrderVo[] = [];
    this.dtg_IconList.rows.forEach((row) => {
      updateList.push(new UpdateCwsIconPublishOrderVo(
        row.dataItem.iconCode,
        row.dataItem.publishOrder
      ))
    })
    this.updateCwsIconPublishOrderService.execute(updateList, () => {});
    this.changeFlag = false;
  }

  /**
   * 閉じる ボタン 押下
   *
   * @memberof KYMW1509Component
   */
  onClickClose() {
    if (this.changeFlag) {
      this.dialogService.openAlertGetMessage('Q0169', null, (c) => {
        if (c === PlessAlert.Yes) {
          super.onClickClose();
        }
      });
    } else {
      super.onClickClose();
    }
  }
}
